<template lang="pug">
  main
    NavBarTPA
    Loader(v-show="isLoading")
    section.section(v-show="!isLoading")
      .container
        .columns.has-text-dark
          .column.is-half.is-offset-one-quarter.has-text-centered.section-title
            h1.title Aplicaciones TPA &nbsp
        .columns.has-text-centered.is-centered.is-multiline.has-text-dark
          .column.is-3(v-show="verSCA")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-file-invoice-dollar.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 SCA Tuxpan
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/TPA/SCA/") Entrar
          .column.is-3(v-show="verAccesos")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-truck-moving.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Accesos
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/TPA/SCA/Accesos") Entrar
          .column.is-3(v-show="verGIA")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-tag.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Sistemas e Instrumentación
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/HomeGia") Entrar
          .column.is-3(v-show="verReportes")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-file-signature.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Reportes
                br
                a.button.is-dark.is-rounded(@click="irReportes") Entrar
          .column.is-3(v-show="verTurnos")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-ticket-alt.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Turnos
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/TPA/SCA/Turnos") Entrar
          .column.is-3(v-show="verNominaciones")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-clipboard-list.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Nominaciones
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/TPA/SCA/Nominaciones") Entrar
          .column.is-3(v-show="verNominaciones")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-truck-moving.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Autotanques
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/TPA/SCA/Autotanques") Entrar
          .column.is-3(v-show="verResponsivas")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-file-signature.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Responsivas
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/Responsivas") Entrar
          .column.is-3(v-show="verRequisiciones")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-shopping-cart.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Requisiciones
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/Requisiciones") Entrar
          .column.is-3(v-show="verDocumentacionIRGE")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-clipboard-check.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Documentados IRGE
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/SCA/IRGE") Entrar
          .column.is-3(v-show="verCombustible")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-car.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Transportes
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/Transportes") Entrar
          .column.is-3
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-laptop-medical.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Soporte
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/Soporte") Entrar
          .column.is-3(v-show="verInventarios")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-cart-arrow-down.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Inventarios de Equipos Asignados
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(:to="isAlmacenistaCede ? '/Inventario/Administracion':'/Inventario/Asignaciones'") Entrar
          .column.is-3(v-show="verMonitor")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-industry.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Monitoreo
                br
                a.button.is-dark.is-rounded(@click="irMonitoreo") Entrar
          .column.is-3(v-show="isAlmacenistaCede")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-shopping-cart.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 Almacén
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/Inventario/Almacen") Entrar
          .column.is-3(v-show="verVideos")
            .card
              .card-content
                span.icon.is-large.is-size-6
                  span.fa-stack.fa-lg
                    i.fas.fa-circle.fa-stack-2x
                    i.fas.fa-file-video.fa-stack-1x.fa-inverse
                p.has-text-weight-medium.is-size-5 DucterTube
                br
                router-link.a.button.is-dark.is-rounded.is-size-6(to="/ducterTube/") Entrar
        .columns.has-text-centered.is-centered.is-mobile
            .column.is-3-desktop.is-4-mobile-desktop.is-4-mobile(v-show="verCH")
              .card
                .card-content
                  span.icon.is-large.is-size-6
                    span.fa-stack.fa-lg
                      i.fas.fa-circle.fa-stack-2x
                      i.fas.fa-clock.fa-stack-1x.fa-inverse
                  p.has-text-weight-medium.is-size-5 Consulta Histórica
                  br
                  router-link.a.button.is-dark.is-rounded.is-size-6(to='/ConsultaHistorica') Entrar
            .column.is-3-desktop.is-4-mobile(v-show="verEDA")
              .card
                .card-content
                  span.icon.is-large.is-size-6
                    span.fa-stack.fa-lg
                      i.fas.fa-circle.fa-stack-2x
                      i.fas.fa-download.fa-stack-1x.fa-inverse
                  p.has-text-weight-medium.is-size-5 Expediente de Descarga Actual
                  br
                  router-link.a.button.is-dark.is-rounded.is-size-6(to='/ExpedienteDescarga') Entrar
            .column.is-3-desktop.is-4-mobile
              .card
                .card-content
                  span.icon.is-large.is-size-6
                    span.fa-stack.fa-lg
                      i.fas.fa-circle.fa-stack-2x
                      i.fas.fa-archive.fa-stack-1x.fa-inverse
                  p.has-text-weight-bold SASISOPA
                  br
                  router-link.a.button.is-dark.is-rounded(to='/Apartado/SASISOPA') Entrar

</template>

<script>
import Loader from '@/components/shared/Loader.vue'
import NavBarTPA from '@/components/layout/NavBarTPA.vue'
import { mapState } from 'vuex'
import InventarioServices from '@/services/inventario/inventario';
import ticketServices from "@/services/soporte/tickets"

export default {
  name: 'HomeTPA',
  components: { Loader, NavBarTPA },
  data () {
    return {
      isLoading: false,
      verSCA: false,
      verAccesos: false,
      verGIA: false,
      verReportes: false,
      verNominaciones: false,
      verResponsivas: false,
      verRequisiciones: false,
      verDocumentacionIRGE: false,
      verCombustible: false,
      verSoporte: false,
      verInventarios: false,
      verMonitor: false,
      isAlmacenistaCede: false,
      verTurnos: false,
      verAlmacen: false,
      verVideos: false,
      verCH: false,
      verEDA: false,
    }
  },
  methods: {
    obtenerUser() {
      if (Object.keys(this.userLogin).length === 0) {
        this.$router.push('/')
      } else {

        if (this.permisos.combustibles != 2) {
          this.verCombustible = true
        }

        if (this.permisos.facturas != 2) {
          this.verFacturas = true
        }

        if (this.permisos.inventarios != 2) {
          this.verInventarios = true
        }

        if (this.permisos.monitoreo != 2) {
          this.verCH = this.permisos.monitoreo == 1
          this.verEDA = this.permisos.monitoreo == 1
          this.verMonitor = true
        }

        if (this.permisos.reportes != 2) {
          this.verReportes = true
        }

        if (this.permisos.responsivas != 2) {
          this.verResponsivas = true
        }

        if (this.permisos.requisiciones != 2) {
          this.verRequisiciones = true
        }
        /*
        if (this.permisos.sca_irge != 2) {
          this.verSCA = true
        }
        */

        if (this.permisos.sca_tpa != 2) {
          this.verSCA = true
        }

        if (this.permisos.visitas != 3) {
          this.verVisitas = true
        }

        if (this.permisos.permisos_videos == 1) {
          this.verVideos = true
        }

        if (this.verSCA) {
          if (this.permisos.sca_tpa == 1) {
            this.verNominaciones = true
          }
        }

        if (this.userLogin.departamento == 3 || this.userLogin.departamento == 6) {
          this.verGIA = true
          this.$store.commit('selectAlmacen', 'g')
        } else {
          this.$store.commit('selectAlmacen', 'c')
        }

        if (this.verInventarios) {
          if (this.permisos.inventarios == 4) {
            this.isAlmacenistaCede = true
          }
        }
      }
      //this.checkSolicitudesPendientes()
      if (this.userLogin.departamento === 1 || this.userLogin.departamento === 3 || this.userLogin.departamento === 6) {
        this.checkTickets()
      }
    },
    irSca () {
      var currentUrl = window.location.hostname
      console.log(currentUrl)
      location.href = '/SCA_Tuxpan/principal.html'
    },
    irReportes () {
      location.href = '/reportesApp/home.html'
    },
    irMonitoreo () {
      console.log('Ir a monitorear' + this.estacionSel)
      this.$router.push('/Monitor')
    },
    checkSolicitudesPendientes () {
      switch (this.userLogin.categoria) {
        case 0:
          console.log('gerentes')
          InventarioServices.getSolicitudes_ubicacion(this.userLogin.ubicacion, 'ALL')
          .then( res => {
            let sol_depto = res.filter( sol => sol.estado === '2')
              if ( sol_depto.length > 0 ) {
                this.displayToast(sol_depto.length, 'Solicitud Nueva', 'Solicitudes Nuevas', 'Ver Solicitudes', '/Solicitudes')
              }
          })
          break
        case 2:
          console.log('jefes de area')
          InventarioServices.getSolicitudes_depto(this.userLogin.departamento, 'ALL')
            .then( res => {
              console.log(res)
              let sol_depto = res.filter( sol => sol.estado === '1' && sol.ubicacion === this.userLogin.ubicacion)
                if ( sol_depto.length > 0 ) {
                  this.displayToast(sol_depto.length, 'Solicitud Nueva', 'Solicitudes Nuevas', 'Ver Solicitudes', '/Solicitudes')
                }
            })
          break
        default:
          break
      }
      this.checkRequisicionesPendientes()
    },
    checkRequisicionesPendientes() {
      switch (this.userLogin.categoria) {
        case 0:
          InventarioServices.getRequisiciones_Ubicaciones('TPA', 0)
            .then( res => {
              console.log(res[0].pendientes)
              if (res[0].pendientes > 0) {
                this.displayToast(res[0].pendientes, 'Requisición Pendiente.', 'Requisicones Pendientes', 'Ir a Requisicones', '/Requisiciones')
              }
            })
          break
        case 1:
          console.log('No Se hace nada')
          break
        case 2:
          console.log('No Se hace nada')
          break
        case 3:
          console.log('No Se hace nada')
          break

        default:
          break
      }
      this.getFirmaCombustibles()
    },
    getFirmaCombustibles() {
      //  1 Para Gerente GIA --- REVISÓ
      //  2 Para Gerente Admón --- AUTORIZÓ
      let num = 0
      if (this.userLogin.categoria === 0) {
        num = 2
      } else {
        num = 1
      }
      InventarioServices.getFirmasPendientes_Comb(this.userLogin.id, num)
        .then((data) => {
          let pendientes = data[0].pendientes
          if ( pendientes > 0) {
            let strPend = pendientes == 1? 'Requisición Pendiente' : 'Requisiciones Pendientes'
            let mensaje = `${pendientes} ${strPend}`
            this.displayToast(mensaje,'done','Ir a Combustible', '/Requisciones')
          }
        })
        .catch((e) => console.log(e))
      this.checkAsinacionesCombustible()
    },
    checkAsinacionesCombustible() {
      InventarioServices.getComb_Asignaciones_Usuario(this.userLogin.id)
        .then( (data) => {
          if (parseInt(data[0].total) > 0) {
            this.tieneAsignaciones = true
          } else {
            this.tieneAsignaciones = false
          }
        })
        .catch( (e) => console.log(e))
    },
    checkTickets() {
      console.log('checkTickets')
      switch (parseInt(this.userLogin.categoria)) {
        case 0:
          ticketServices.searchAll(this.userLogin.departamento)
            .then((data) => {
              console.log(data)
              let ticketsPend = data.filter((tick) => parseInt(tick.compra) == 1).length
              console.log(ticketsPend)
              this.sendNotification_tickets(ticketsPend)
            })
            .catch((e)=> {
              this.displayToast(e.message,'ban','Ok','')
            })
          break
        case 2:
          ticketServices.searchTicket_area(this.userLogin.departamento)
            .then((data) => {
              console.log(data)
              let ticketsPend = data.filter((tick) => parseInt(tick.compra) == 1).length
              console.log(ticketsPend)
              this.sendNotification_tickets(ticketsPend)
            })
            .catch((e)=> {
              this.displayToast(e.message,'ban','Ok','')
            })
          break
        case 3:
          ticketServices.searchTicket_user(this.userLogin.id, 'a')
            .then((data) => {
              console.log(data)
              let ticketsPend = data.filter((tick) => parseInt(tick.estado) < 1).length
              console.log(ticketsPend)
              this.sendNotification_tickets(ticketsPend)

            })
            .catch((e)=> {
              this.displayToast(e.message,'ban','Ok','')
            })
          break

        default:
          break
      }
    },
    sendNotification_tickets(ticketsPend) {
      if (ticketsPend > 0) {
        let textToast = ''
        if (ticketsPend == 1) {
          textToast = `${this.userLogin.nombre} tiene ${ticketsPend} ticket pendiente.`
        } else {
          textToast = `${this.userLogin.nombre} tiene ${ticketsPend} tickets pendientes.`
        }
        this.displayToast(textToast,'done','Ir a Soporte','/Soporte')
      }
    },
    displayToast(message, icon, actionText, destiny) {
      let toast = this.$toasted.show(message, {
        theme: "toasted-primary",
        position: "bottom-right",
        duration : 3000,
        iconPack: 'fontawesome',
        icon: icon,
        action : {
          text : actionText,
          onClick : (e, toastObject) => {
            console.log(destiny)
            this.$router.push(destiny)
            toastObject.goAway(0)
          }
        },
      })
    },
  },
  computed: {
    ...mapState(['logueado', 'userLogin', 'permisos'])
  },
  created () {
    this.obtenerUser()
  },
}
</script>

<style lang="css" scoped>

  .image {
    display: inline-block;
  }

  .card:hover {
    transform: translateY(-5px) scale(1.005) translateZ(0);
    box-shadow: 0 24px 36px rgba(0,0,0,0.11), 0 14px 16px rgba(0,0,0,0.11);
  }

  .section-title {
    margin-top: 1rem;
    margin-bottom: 2rem;
  }

  .card {
    color: #54545c;
  }

</style>



// WEBPACK FOOTER //
// src/components/HomeTPA.vue